import createCollectionResource from 'src/actions/shared/createResource';
import { ChatCampaign } from 'src/models/ChatCampaigns/ChatCampaign';
import { toastError } from '../toast';
import { translateErrors } from 'src/adapters/validateType';

import { DomainError as StandardDomainError, Unauthorized } from '@ad-scripts/application/lib/error';
import { logout } from 'src/actions/auth/authSlice';
import * as sharedTypes from 'src/actions/shared/sharedTypes';
import { matchesError } from 'src/models/DomainError';

const chatCampaignsResource = createCollectionResource<ChatCampaign>({
  name: 'chatCampaigns',
  endpoint: 'v1/orgs/:orgId/chat-campaigns/:id',
  type: ChatCampaign,
  options: {
    getErrorMessage: err => {
      if (matchesError(err, { attr: 'name', code: 'invalid' })) {
        return 'You have exceeded the character count';
      }
      if (matchesError(err, { attr: 'description', code: 'invalid' })) {
        return 'You have exceeded the character count';
      }
      if (matchesError(err, { attr: 'priority', code: 'invalid' })) {
        return 'Invalid order number';
      }
    },
    toastMessages: {
      onAdd: campaign => `${campaign.name} created!`,
      onUpdate: campaign => `${campaign.name} updated!`,
      onRemove: () => 'Delete successful!',
    },
  },
});

const updateChatCampaignStatus: sharedTypes.AppThunk =
  (params: any, attrs: any) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(updateStarted({}));
      await gateways.chatCampaigns.replace(params, attrs);
      dispatch(updateSuccess({}));
      dispatch(broadcast(attrs));
    } catch (err) {
      if (err instanceof StandardDomainError) {
        dispatch(updateError(translateErrors(err.errors)));
      } else if (err instanceof Unauthorized) {
        dispatch(logout());
      } else {
        dispatch(updateRequestError(err));
      }
      dispatch(toastError('There was an error while updating'));
    }
  };

chatCampaignsResource.effects.updateChatCampaignStatus = updateChatCampaignStatus;

const { broadcast, updateError, updateRequestError, updateStarted, updateSuccess } = chatCampaignsResource.actions;

export default chatCampaignsResource;
